<template>
  <div class="div-layout tab-resetStyle">
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="系统通知" name="system">
        <system-notification />
      </el-tab-pane>
      <el-tab-pane label="手动通知" name="manual">
        <manual-notification v-if="manualLoadingItem" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SystemNotification from './systemNotification/index.vue';
import ManualNotification from './manualNotification/index.vue';

export default {
  name: 'UpgradeSMSNotification',
  components: {
    SystemNotification,
    ManualNotification
  },
  data() {
    return {
      activeName: 'system',
      manualLoadingItem: false // 表格刷新loading
    };
  },

  mounted() {
    this.manualLoadingItem = false;
  },

  methods: {
    handleTabClick(tab, event) {
      this.manualLoadingItem = false;
      if (tab.name === 'manual') {
        this.manualLoadingItem = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
